/**
 * eventsService.js
 * All API calls for the Events & Reminders module.
 * Uses the same axios instance as the rest of the app.
 */

import axios from 'axios';

// ─── Events CRUD ──────────────────────────────────────────────────────────────

export const createEvent = (formData) =>
    axios.post('/events', formData);

export const getEvents = (params = {}) =>
    axios.get('/events', { params });

export const getEventById = (id) =>
    axios.get(`/events/${id}`);

export const updateEvent = (id, formData) =>
    axios.put(`/events/${id}`, formData);

export const deleteEvent = (id) =>
    axios.delete(`/events/${id}`);

export const cancelEvent = (id, reason) =>
    axios.post(`/events/${id}/cancel`, { reason });

// ─── Acknowledge ──────────────────────────────────────────────────────────────

export const acknowledgeEvent = (id, rsvp) =>
    axios.post(`/events/${id}/acknowledge`, { rsvp });

// ─── Reschedule ───────────────────────────────────────────────────────────────

export const rescheduleEvent = (id, payload) =>
    axios.post(`/events/${id}/reschedule`, payload);

export const getScheduleHistory = (id) =>
    axios.get(`/events/${id}/history`);

// ─── Snooze ───────────────────────────────────────────────────────────────────

export const snoozeEvent = (id, duration) =>
    axios.post(`/events/${id}/snooze`, { duration });

export const getSnoozeStatus = (id) =>
    axios.get(`/events/${id}/snooze-status`);

// ─── Audit ────────────────────────────────────────────────────────────────────

export const getEventAuditLog = (id) =>
    axios.get(`/events/${id}/audit`);

// ─── Analytics ────────────────────────────────────────────────────────────────

export const getReminderDistribution = (params = {}) =>
    axios.get('/events/analytics/distribution', { params });

export const getSnoozedVsRescheduledTrend = (params = {}) =>
    axios.get('/events/analytics/trend', { params });

export const getAnalyticsSummary = (params = {}) =>
    axios.get('/events/analytics/summary', { params });

export const getFilterOptions = () =>
    axios.get('/events/analytics/filters');

// ─── Bulk Import ──────────────────────────────────────────────────────────────

export const previewImport = (fileOrRows) => {
    if (Array.isArray(fileOrRows)) {
        // Send as JSON for re-validation
        return axios.post('/events/import/preview', { rows: fileOrRows });
    }
    // Send as FormData for initial upload
    const fd = new FormData();
    fd.append('file', fileOrRows);
    return axios.post('/events/import/preview', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const confirmImport = (file, importLogId, rows = null) => {
    if (rows && Array.isArray(rows)) {
        // Send as JSON if we have the rows (supports correction/removal from preview)
        return axios.post('/events/import/confirm', { importLogId, rows });
    }

    const fd = new FormData();
    if (file) fd.append('file', file);
    if (importLogId) fd.append('importLogId', importLogId);
    return axios.post('/events/import/confirm', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const getImportLogs = () =>
    axios.get('/events/import/logs');

// ─── Tab Counts ────────────────────────────────────────────────────────────────
export const getTabCounts = (params = {}) =>
    axios.get('/events/tab-counts', { params });
